module.exports = __webpack_public_path__ + "bab2d982a2c7476d0b079d51309f3e08.png";